// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__11u9p","footer":"ModalInfo_footer__3XGrA"};